var CasinoSearchArray = [
  "101 Poker Club: Texas",
  "4 Bears Casino & Lodge: North Dakota",
  "Ace's Poker Lakewood: Washington",
  "Ace's Poker Mountlake Terrace: Washington",
  "Agua Caliente Casino, Palm Springs: California",
  "Alamo City Poker Club: Texas",
  "All Star Casino: Washington",
  "Amarillo Social Club: Texas",
  "Aria Resort & Casino, Las Vegas: Nevada",
  "Bally's Black Hawk: Colorado",
  "Bally's Twin River Lincoln: Rhode Island",
  "Bay 101: California",
  "Bear River Casino Hotel: California",
  "Beau Rivage Casino & Resort: Mississippi",
  "Bellagio Hotel & Casino: Nevada",
  "bestbet Jacksonville: Florida",
  "bestbet St. Augustine: Florida",
  "Bestbet, Orange Park: Florida",
  "Black Pearl Restaurant & Card Room: Washington",
  "Boomtown Casino & Hotel, New Orleans: Louisiana",
  "Borgata Hotel Casino & Spa: New Jersey",
  "Broadway Grill & Pizzeria: Washington",
  "Buzz Inn Steakhouse East Wenatchee: Washington",
  "Caesars Palace, Las Vegas: Nevada",
  "Caesars Virginia: Virginia",
  "Canterbury Park: Minnesota",
  "Capitol Casino: California",
  "Caribbean Cardroom: Washington",
  "Casino 99: California",
  "Casino Caribbean Kirkland: Washington",
  "Casino Caribbean Yakima: Washington",
  "Casino Club: California",
  "Casino del Sol: Arizona",
  "Central Coast Casino: California",
  "Champions Club Texas: Texas",
  "Champions Social Club: Texas",
  "Clearwater Saloon & Casino: Washington",
  "Club 52 Poker at Melbourne Greyhound Park: Florida",
  "Club One Casino: California",
  "Club San Rafael: California",
  "Commerce Casino: California",
  "Crazy Moose Casino Pasco: Washington",
  "Daytona Beach Kennel Club & Poker Room, Williamson Blvd: Florida",
  "Derby Lane Poker Room: Florida",
  "Desert Diamond Casino & Hotel, Tucson: Arizona",
  "Desert Diamond Casino, West Valley: Arizona",
  "Doghouse Poker Club: Texas",
  "Ebro Poker Room: Florida",
  "El Dorado Hills Casino: California",
  "Emerald Princess Casino: Georgia",
  "Empire Poker Club: Texas",
  "FireKeepers: Michigan",
  "Fortune Casino La Center: Washington",
  "Fortune Casino Lacey: Washington",
  "Fortune Poker Renton: Washington",
  "Four Winds Casino South Bend: Indiana",
  "Foxwoods Casino & Resort: Connecticut",
  "Garlic City Casino & Restaurant: California",
  "Golden West Casino: California",
  "Grand Victoria Casino: Illinois",
  "Graton Resort & Casino: California",
  "Green Valley Ranch Resort, Casino & Spa: Nevada",
  "Gun Lake Casino: Michigan",
  "Hard Rock Casino Rockford: Illinois",
  "Harrah's Pompano Beach: Florida",
  "Harrahs Casino & Resort, Cherokee: North Carolina",
  "Harrahs Casino, New Orleans: Louisiana",
  "Hollywood Casino @ Kansas Speedway: Kansas",
  "Hollywood Casino, Columbus: Ohio",
  "Hollywood Park Casino: California",
  "Hon-Dah Casino: Arizona",
  "Horseshoe Casino, Council Bluffs: Iowa",
  "Horseshoe Casino, Southern Indiana: Indiana",
  "Horseshoe Indianapolis: Indiana",
  "Horseshoe Las Vegas: Nevada",
  "Imperial Palace Casino Auburn: Washington",
  "Isleton Casino: California",
  "Jack Casino, Cleveland: Ohio",
  "Jackson Rancheria Casino: California",
  "Jamestown Saloon: Washington",
  "Joker's Casino and Sports Bar: Washington",
  "Kickapoo Lucky Eagle Casino & Hotel: Texas",
  "Lancer Lanes and Casino: Washington",
  "Larry Flynt's Lucky Lady Casino: California",
  "Lilac Lanes & Casino: Washington",
  "Little Creek Casino Resort: Washington",
  "Livermore Casino: California",
  "Lone Butte Casino: Arizona",
  "Lucky Chances: California",
  "Lucky's Card Room (TGT Poker): Florida",
  "Mandalay Bay, Las Vegas: Nevada",
  "Maryland Live! Casino: Maryland",
  "Merced Poker Room: California",
  "MGM Grand, Detroit: Michigan",
  "MGM Grand, Las Vegas: Nevada",
  "Mohegan Sun Pocono: Pennsylvania",
  "Mohegan Sun: Connecticut",
  "Naples Fort Myers Kennel Club & Poker Room: Florida",
  "Nineteenth Hole: California",
  "North Coast Casino: California",
  "Ocala Bets: Florida",
  "Ocean's 11 Casino: California",
  "Oceanview Card Room: California",
  "One-Eyed Jack's Poker Room: Florida",
  "Orange City Racing and Card Club: Florida",
  "Outlaws Card Parlour: California",
  "Oxford Downs: Florida",
  "Palace Poker Texas: Texas",
  "Palm Beach Kennel Club, West Palm Beach: Florida",
  "Parkwest Casino Cordova: California",
  "Parkwest Casino Lodi: California",
  "Parkwest Casino Manteca: California",
  "Parx Casino: Pennsylvania",
  "Pensacola Greyhound Park Poker Room: Florida",
  "Players Casino: California",
  "Poker House Fort Worth: Texas",
  "Prairie Meadows: Iowa",
  "Razzals Bar & Grill: Washington",
  "Red Rock Casino Resort & Spa: Nevada",
  "Rivers Casino Portsmouth: Virginia",
  "Rivers Casino, Des Plaines: Illinois",
  "Rivers Casino: Pennsylvania",
  "Roxbury Lanes Casino: Washington",
  "Running Aces Casino & Racetrack: Minnesota",
  "SA Card House: Texas",
  "Saracen Casino Resort: Arkansas",
  "Seminole Casino, Coconut Creek: Florida",
  "Seminole Hard Rock Hotel & Casino, Hollywood: Florida",
  "Seminole Hard Rock Hotel & Casino, Tampa: Florida",
  "Shuffle 214: Texas",
  "Shuffle 512: Texas",
  "Slo Pitch Pub & Eatery: Washington",
  "Soaring Eagle Casino & Resort: Michigan",
  "South Point Hotel, Casino & Spa: Nevada",
  "Spades Poker House Baytown: Texas",
  "Spades Poker House Webster: Texas",
  "Stars Casino: California",
  "Stones Gambling Hall: California",
  "Sycuan Casino: California",
  "Talking Stick: Arizona",
  "Tampa Bay Downs: Florida",
  "TCH Social Austin: Texas",
  "TCH Social Las Colinas: Texas",
  "Texas Card House Dallas: Texas",
  "Texas Card House Houston: Texas",
  "Texas Card House Rio Grande Valley: Texas",
  "Texas Card House Spring: Texas",
  "The Aviator Casino: California",
  "The Bicycle Hotel & Casino: California",
  "The Big Easy Casino: Florida",
  "The Casino @ Dania Beach: Florida",
  "The Fort Card Room: Texas",
  "The Gardens Casino: California",
  "The Hangar Poker House: Texas",
  "The Lodge Card Club Round Rock: Texas",
  "The Lodge Card Club San Antonio: Texas",
  "The Orleans Hotel & Casino: Nevada",
  "The Sands Casino, Bethlehem: Pennsylvania",
  "The Venetian: Nevada",
  "Thunder Valley Casino: California",
  "Towers Casino & Card Room: California",
  "Turlock Poker Room: California",
  "Turning Stone Resort & Casino: New York",
  "Westgate Las Vegas Resort & Casino: Nevada",
  "Wheeling Island Hotel, Casino & Racetrack: West Virginia",
  "Wynn, Las Vegas: Nevada"
];

module.exports = CasinoSearchArray;



// WEBPACK FOOTER //
// ./js/casino-search-array.js